import React, { createContext, useReducer } from 'react';
import eventActions from '../actions/eventActions';
import eventReducer from '../reducers/eventReducer';

export const EventContext = createContext();

const EventContextProvider = (props) => {
  const [eventState, dispatch] = useReducer(eventReducer, {
    eventProgress: false,
    eventLoaded: false,
    eventError: null,
    hasTicketAccess: true,
    event: null,
  });
  const actions = eventActions(dispatch);

  return (
    <EventContext.Provider value={{ eventState, dispatch, actions }}>
      {props.children}
    </EventContext.Provider>
  );
};

export default EventContextProvider;
